import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class TechnicalsService {
    constructor(private http: HttpClient) {}

    findMailQueueSize(): Observable<number> {
        return this.http.get<number>('/management/mail-queue');
    }

    findBddDumps(): Observable<string[]> {
        return this.http.get<string[]>('/api/technical/bdd-dump');
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/technical/technicals.service.ts